export default function() {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${widgetName}`).videoWidget({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
      , detectIpad: IPADDETECTED
      ,poster: 'https://cdn.saffire.com/images.ashx?t=ig&rid=IndyMini&i=thumnailyoutube.JPG'
      // options
      , multiVideo: false
      , showOnMobile: true
      , maxVideos: 1
      ,autoPlayVideo: true
      ,loopVideo: true
      , trackingGA: {
        present: false,
        event: 'event',
        gaObj: {
          eventCategory: 'Videos',
          eventAction: '',
          eventLabel: '',
        }
      }
      
      , videoWidgetLoaded: function(){
        let videoSrc = $('#videoWidget iframe').attr('src');
        $('#videoWidget iframe').attr('src', `${videoSrc}&amp;start=1&amp;controls=0&autoPlayVideo=true`);
        
      }
  });

};
